import { createAction } from 'redux-actions';

export const setLanguage = createAction('SET_LANGUAGE');
export const setCurrency = createAction('SET_CURRENCY');
export const setCookiesPolicyDismissed = createAction('COOKIES_POLICY_DISMISSED');